import {
  ChangeDetectorRef,
  Component,
  HostListener,
  Inject,
  OnInit,
  PLATFORM_ID
} from '@angular/core';

import {
  HttpClient
} from '@angular/common/http';

import {
  Router,
  RouterModule
} from '@angular/router';

import {
  FormsModule
} from '@angular/forms';

import {
  CommonModule,
  isPlatformBrowser
} from '@angular/common';

import {
  Sidebar
} from '../sidebar/sidebar';

import {
  CartService
} from '../../services/cart';

import {
  ProductStateService
} from '../../services/product-state.service';

import {
  AppLanguage,
  LanguageService
} from '../../services/language.service';

import {
  MapLoaderService
} from '../../services/maploader.service';

import {
  SettingsService
} from '../../services/settings.service';


@Component({
  selector: 'app-navbar',

  standalone: true,

  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    Sidebar
  ],

  templateUrl: './navbar.html',

  styleUrls: [
    './navbar.scss'
  ]
})
export class Navbar implements OnInit {

  private readonly isBrowser: boolean;

isMobile = false;

  /* =========================
     SEARCH
  ========================= */

  searchText = '';
showMobileSearch = false;

  /* =========================
     LOCATION
  ========================= */

  selectedLocation = 'Dhaka';

  showLocationMenu = false;

  // 'main' -> ছোট মেনু (Use my current location / Change City)
  // 'cities' -> সিটি লিস্ট
  locationMenuStep:
    'main' | 'cities' = 'main';

  locatingCurrentLocation = false;

  /* =========================
     LOCATION — AUTO-DETECT CONFIRM
     (silent GPS/IP auto-detect ভুল এলাকা বসিয়ে দিলেও
     আগে user টেরই পেত না — এখন auto-detect হলে একটা
     ছোট prompt দেখায়, "এটা কি ঠিক?" — ভুল হলে এক ক্লিকে
     city/search স্টেপে চলে যাওয়া যায়। ম্যানুয়াল "Use My
     Location" ক্লিকের বেলায় এই prompt দেখানো হয় না, কারণ
     সেটা তো user নিজেই ইচ্ছা করে ট্রিগার করেছে)
  ========================= */

  showAutoLocationConfirm = false;

  private autoLocationConfirmTimer: any = null;

  /* =========================
     LOCATION — MANUAL SEARCH
     (Nominatim/OSM forward-geocode আগে থেকেই
     mapLoader.search() এ ছিল, এখানে শুধু UI
     জোড়া লাগানো হলো — city list-এর উপরে একটা
     সার্চ বক্স, ইউজার নিজের এলাকা টাইপ করলে
     matching জায়গার লিস্ট দেখাবে)
  ========================= */

  locationSearchText = '';

  locationSearchResults:
    Array<{ label: string; lat: number; lng: number }> = [];

  locationSearching = false;

  private locationSearchDebounce: any = null;

  // "Location is off, help me turn it on" modal
  // (mobile + desktop উভয় জায়গা থেকেই এই একই
  // modal ট্রিগার হয় — useCurrentLocationNavbar() থেকে)
  showLocationHelp = false;

  locationHelpReason:
    'denied' | 'unavailable' | 'timeout' | 'unsupported' = 'denied';


  /* =========================
     CHAT
     (Admin panel > Footer Management থেকে
     এই লিংক/নাম্বারগুলো বদলানো যায়)
  ========================= */

  showChat = false;

  readonly footerApi =
    'https://superbangladesh-api-1.onrender.com/api/footer-settings/active';

  chatContact = {
    phone: '+8801756442133',
    messengerUrl: 'https://www.facebook.com/share/1C1rQ6txJr/',
    whatsappNumber: '8801756442133',
    instagramUrl: ''
  };


  /* =========================
     SITE LOGO
     (Admin panel > Site Settings থেকে
     লোগো পরিবর্তন করা যায়)

     ⚠️ LOGO FIX v2: প্রথমে fallback হিসেবে favicon.ico
     ব্যবহার করা হয়েছিল, কিন্তু সেটা আসলে Angular CLI-র
     ডিফল্ট গোলাপি "A" আইকন — তাই reload করলে ১ সেকেন্डের
     জন্য ভুল ব্র্যান্ডের আইকন ফ্ল্যাশ করতো, তারপর আসল
     লোগো লোড হয়ে ঠিক হয়ে যেত। এখন fallback হলো সম্পূর্ণ
     transparent ১x১ pixel — তাই লোড হওয়ার আগ পর্যন্ত কোনো
     ভুল আইকনই দেখাবে না, শুধু পাশের "Super Bangladesh"
     লেখাটা দেখা যাবে (brand-logo-র width/height ফিক্সড
     থাকায় কোনো layout jump ও হবে না)।
  ========================= */

  readonly fallbackLogoUrl =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ycQAOw==';

  // ✅ নতুন লোগো (স্বচ্ছ ব্যাকগ্রাউন্ড, শুধু লোগো) — assets/images থেকে
  readonly brandLogoUrl = 'assets/images/super-bangladesh-logo.png';

  logoUrl = this.brandLogoUrl;


  /* =========================
     MOBILE CATEGORY SIDEBAR
  ========================= */

  sidebarOpen = false;


  /* =========================
     DESKTOP 3-DASH MENU
  ========================= */

  desktopMenuOpen = false;


  /* =========================
     CONSTRUCTOR
  ========================= */

  constructor(
    public cart: CartService,
    private router: Router,
    private state: ProductStateService,
    public languageService: LanguageService,
    private mapLoader: MapLoaderService,
    private http: HttpClient,
    private settingsService: SettingsService,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) platformId: Object
  ) {

    this.isBrowser =
      isPlatformBrowser(platformId);

    // ✅ window/localStorage শুধু browser-এ পড়া হচ্ছে,
    // যাতে SSR/prerender এর সময় এই কম্পোনেন্ট ভেঙে না যায়
    // (এটাই মোবাইল লোকেশন বার মাঝে মাঝে না দেখানোর কারণ ছিল)
    if (this.isBrowser) {

      this.isMobile =
        window.innerWidth <= 768;

      this.selectedLocation =
        localStorage.getItem(
          'selectedLocation'
        ) || 'Dhaka';
    }
  }


  ngOnInit(): void {

    // ⚠️ IP-GEOLOCATION AUTO-DETECT: Chaldal-এর মতোই, GPS permission
    // popup ছাড়াই সাইটে ঢোকা মাত্র IP address থেকে আন্দাজ এলাকা বসিয়ে
    // দেয়া হয় — যাতে নতুন ভিজিটর শুধুই "Dhaka" ডিফল্ট না দেখে একটা
    // বেশি প্রাসঙ্গিক এলাকা দেখেন। ইউজার আগে কখনো নিজে city/এলাকা
    // বেছে থাকলে (localStorage-এ selectedLocation থাকলে) সেটাই
    // respect করা হয়, IP-location দিয়ে override করা হয় না। নিচের
    // GPS permission-granted ব্লক এরপরও চলবে এবং পাওয়া গেলে এই IP
    // অনুমানের চেয়ে বেশি সঠিক GPS লোকেশন দিয়ে সেটা replace করে দেবে।
    if (this.isBrowser && !localStorage.getItem('selectedLocation')) {
      this.detectLocationByIP();
    }

    // Admin panel > Site Settings থেকে বসানো লোগো লোড হয়
    // (না পেলে ডিফল্ট favicon-ই থেকে যাবে)
    //
    // ⚠️ ZONELESS FIX: এই অ্যাপে zone.js নেই (Angular zoneless),
    // তাই HttpClient response আসার পরে plain field (this.logoUrl)
    // বদলালেও Angular নিজে থেকে re-render করে না — যতক্ষণ না কোনো
    // click-এর মতো Angular-tracked event CD চালায়। এই জন্যই আগে
    // লোগো প্রথমে ভাঙা দেখাতো, আর লোগোতে ক্লিক করলে (যেটা একটা
    // Angular click event, তাই CD চলে) ঠিক হয়ে যেত। markForCheck()
    // এখন response আসামাত্রই re-render বাধ্য করে।
    this.settingsService
      .getSettings()
      .subscribe({
        next: (res) => {

          // লোগো এখন প্রজেক্টের নিজের ফাইল (brandLogoUrl) থেকে আসে,
          // তাই Admin Settings-এর পুরনো logoUrl দিয়ে বদলানো হয় না।

          this.cdr.markForCheck();
        },
        error: () => {
          // API না পেলেও ডিফল্ট লোগো দিয়ে navbar কাজ করবে
        }
      });

    // Admin panel এ Footer Management থেকে বসানো
    // Messenger/WhatsApp/Instagram লিংক এখানে লোড হয়
    this.http
      .get<any>(this.footerApi)
      .subscribe({
        next: (res) => {

          if (!res) {
            return;
          }

          if (res.phone) {
            this.chatContact.phone = res.phone;
          }

          if (res.messengerUrl) {
            this.chatContact.messengerUrl = res.messengerUrl;
          }

          if (res.whatsappNumber) {
            this.chatContact.whatsappNumber = res.whatsappNumber;
          }

          if (res.instagramUrl) {
            this.chatContact.instagramUrl = res.instagramUrl;
          }

          this.cdr.markForCheck();
        },
        error: () => {
          // API না পেলেও আগের ডিফল্ট নাম্বার/লিংক দিয়ে চ্যাট বাটন কাজ করবে
        }
      });

    // ⚠️ AUTO-DETECT FIX: browser-এ যদি location permission আগে থেকেই
    // "granted" থাকে (আগে কখনো Allow করা ছিল), তাহলে user-কে আলাদা
    // করে "Use My Location" চাপতে হবে না — পেজ লোড হওয়ার সাথে সাথেই
    // silently current location detect করে নেয়া হয়। Permission
    // "prompt"/"denied" থাকলে এখানে কিছুই করা হয় না (পেজ লোড হতেই
    // browser-এর permission popup দেখানো UX-এর দিক থেকে খারাপ, তাই
    // popup শুধু user নিজে "Use My Location"-এ ক্লিক করলেই আসবে)।
    if (
      this.isBrowser &&
      navigator.geolocation &&
      (navigator as any).permissions?.query
    ) {

      (navigator as any).permissions
        .query({ name: 'geolocation' })
        .then((status: PermissionStatus) => {

          if (status.state === 'granted') {
            this.detectCurrentLocationSilently();
          }
        })
        .catch(() => {
          // Permissions API সাপোর্ট না থাকলে (যেমন কিছু পুরনো/iOS
          // Safari) কিছুই হবে না — user manual "Use My Location"
          // দিয়ে detect করতে পারবে, localStorage-এর সেভ করা city
          // ততক্ষণ দেখাবে
        });
    }
  }


  /* =========================
     SILENT LOCATION DETECT
     (permission আগে থেকেই allowed থাকলে,
     কোনো popup/modal ছাড়াই background-এ
     current location বসিয়ে দেয়)
  ========================= */

  /* =========================
     IP-BASED AUTO LOCATION
     (GPS permission ছাড়াই, সাইটে ঢোকা মাত্রই
     IP address থেকে আন্দাজ এলাকা বসিয়ে দেয়)
  ========================= */

  private async detectLocationByIP(): Promise<void> {

    if (!this.isBrowser) {
      return;
    }

    const geo =
      await this.mapLoader.ipLocate();

    if (!geo) {
      return;
    }

    // এই সময়ের মধ্যে ইউজার নিজে manually কিছু বেছে ফেলে থাকলে
    // (city list / search থেকে), বা GPS silent-detect আগেই শেষ
    // হয়ে থাকলে — IP-এর কম-নির্ভুল অনুমান দিয়ে সেটা override
    // করা হবে না
    if (localStorage.getItem('selectedLocation')) {
      return;
    }

    const cityRaw =
      geo.city || geo.area || '';

    const matchedCity =
      this.matchKnownCity(cityRaw);

    const label =
      matchedCity ||
      geo.area ||
      cityRaw ||
      'Dhaka';

    this.selectLocation(label);

    this.flashAutoLocationConfirm();

    this.cdr.markForCheck();
  }


  /* =========================
     AUTO-DETECT CONFIRM PROMPT
     (silent GPS / IP auto-detect এর পরে ডাকা হয় —
     ম্যানুয়াল ক্লিকের সময় এটা ডাকা হয় না)
  ========================= */

  private flashAutoLocationConfirm(): void {

    this.showAutoLocationConfirm = true;

    if (this.autoLocationConfirmTimer) {
      clearTimeout(this.autoLocationConfirmTimer);
    }

    // ৮ সেকেন্ড পর নিজে থেকেই সরে যাবে, যাতে সাইট ব্যবহার করতে
    // বাধা না দেয়
    this.autoLocationConfirmTimer = setTimeout(() => {
      this.showAutoLocationConfirm = false;
      this.cdr.markForCheck();
    }, 8000);
  }


  // "না, এটা আমার এলাকা না" — সরাসরি city/search স্টেপে নিয়ে যায়
  fixAutoLocation(
    event?: MouseEvent
  ): void {

    if (event) {
      event.stopPropagation();
    }

    if (this.autoLocationConfirmTimer) {
      clearTimeout(this.autoLocationConfirmTimer);
    }

    this.showAutoLocationConfirm = false;

    this.locationMenuStep = 'cities';
    this.showLocationMenu = true;
  }


  dismissAutoLocationConfirm(
    event?: MouseEvent
  ): void {

    if (event) {
      event.stopPropagation();
    }

    if (this.autoLocationConfirmTimer) {
      clearTimeout(this.autoLocationConfirmTimer);
    }

    this.showAutoLocationConfirm = false;
  }


  /* =========================
     BUILD SHORT LOCATION LABEL
     (দুই জায়গা থেকেই ব্যবহার হয় — manual "Use My
     Location" ক্লিক আর silent auto-detect দুটোতেই।
     আগে শুধু "Dhaka" এর মতো ৫টা বড় শহরে collapse করে
     ফেলতো, এখন এলাকার নামও রাখে — যেমন "Mirpur, Dhaka")
  ========================= */

  // দুই জায়গা থেকেই ব্যবহার হয় — Nominatim reverse-geocode (GPS/
  // manual search) আর IP-geolocation, দুটোই "Dhaka District"/
  // "Dhaka Division"-এর মতো variation দেয়, তাই আমাদের ৫টা
  // supported city-র সাথে মিলিয়ে নেয়া হয়
  private matchKnownCity(
    cityRaw: string
  ): string | undefined {

    if (!cityRaw) {
      return undefined;
    }

    const knownCities =
      ['Dhaka', 'Chattogram', 'Sylhet', 'Rajshahi', 'Khulna'];

    return knownCities.find((c) =>
      cityRaw.toLowerCase().includes(c.toLowerCase()) ||
      c.toLowerCase().includes(cityRaw.toLowerCase())
    );
  }


  private async buildLocationLabel(
    lat: number,
    lng: number,
    precise: boolean = false
  ): Promise<string> {

    const { area, city, road } =
      await this.mapLoader.reverseGeocodeArea(lat, lng);

    const matchedCity = this.matchKnownCity(city);

    // 🆕 PRECISE MODE (শুধু "Use My Location" GPS ক্লিকে ব্যবহার হয়):
    // road/sector পাওয়া গেলে সেটাও সামনে জুড়ে দেয়া হয় —
    // যেমন "Road 5, Mirpur, Dhaka"। Auto-detect (IP) বা manual
    // search-এ এটা ব্যবহার হয় না, কারণ IP-location এত নির্ভুল না
    // যে road-level দেখানো অর্থবহ হবে।
    if (precise && road) {

      const cityPart =
        matchedCity || area || '';

      if (area && cityPart && area.toLowerCase() !== cityPart.toLowerCase()) {
        return `${road}, ${area}, ${cityPart}`;
      }

      if (cityPart) {
        return `${road}, ${cityPart}`;
      }

      return road;
    }

    if (
      area &&
      matchedCity &&
      area.toLowerCase() !== matchedCity.toLowerCase()
    ) {
      // যেমন: "Mirpur, Dhaka"
      return `${area}, ${matchedCity}`;
    }

    if (matchedCity) {
      return matchedCity;
    }

    if (area) {
      return area;
    }

    // fallback: area/city ফাঁকা এলে আগের full-address পদ্ধতি
    const fullLabel =
      await this.mapLoader.reverseGeocode(lat, lng);

    const matchedFromFull =
      this.matchKnownCity(fullLabel);

    return (
      matchedFromFull ||
      fullLabel ||
      this.selectedLocation
    );
  }


  private detectCurrentLocationSilently(): void {

    if (!this.isBrowser || !navigator.geolocation) {
      return;
    }

    navigator.geolocation.getCurrentPosition(

      async (pos) => {

        const lat = pos.coords.latitude;
        const lng = pos.coords.longitude;

        const label =
          await this.buildLocationLabel(lat, lng);

        this.selectLocation(
          label || this.selectedLocation
        );

        this.flashAutoLocationConfirm();

        this.cdr.markForCheck();
      },

      () => {
        // Permission "granted" থাকলেও কখনো কখনো ডিটেকশন ব্যর্থ হতে
        // পারে (GPS সাময়িক বন্ধ ইত্যাদি) — যেহেতু এটা user-এর নিজের
        // ক্লিক না, silently আগের selected city-ই থেকে যাবে, কোনো
        // error modal/alert দেখানো হবে না।
      },

      {
        // ⚠️ ACCURACY FIX: এখানে আগে enableHighAccuracy: false ছিল,
        // যার মানে ডেস্কটপ/মোবাইল ব্রাউজার আসল GPS চিপ ব্যবহার না
        // করে শুধু WiFi/cell-tower ভিত্তিক আন্দাজ অবস্থান (Google/
        // Mozilla-এর লোকেশন সার্ভিস) ব্যবহার করত — বাংলাদেশে এই
        // WiFi-ভিত্তিক ডেটাবেজ অনেক জায়গায় পুরনো/অসম্পূর্ণ, তাই
        // reverse-geocode করলে কখনো কখনো নিজের এলাকা থেকে বেশ কিছুটা
        // দূরের ভুল এলাকার নাম (যেমন "Paradogar") চলে আসত — অথচ
        // ম্যানুয়াল "Use My Location" বাটন (নিচে useCurrentLocationNavbar)
        // শুরু থেকেই enableHighAccuracy: true ব্যবহার করে বলে সেটা
        // ঠিক আসত। এখন এই silent auto-detect-ও একই enableHighAccuracy:
        // true ব্যবহার করছে, যাতে পেজ লোড হওয়ার সময় প্রথমবারই সঠিক
        // এলাকা আসে।
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  }


  /* =========================
     LOGO IMAGE FAILS TO LOAD
     (admin panel-এর logoUrl নিজেই যদি ভাঙা/৪০৪ হয়,
     তাহলে favicon fallback-এ চলে যাবে — চিরস্থায়ী
     broken-image icon আর দেখাবে না)
  ========================= */

  onLogoError(): void {

    if (this.logoUrl !== this.fallbackLogoUrl) {
      this.logoUrl = this.fallbackLogoUrl;
      this.cdr.markForCheck();
    }
  }


  /* =========================
     CURRENT LANGUAGE
  ========================= */

  get selectedLanguage():
    AppLanguage {

    return this.languageService
      .language();
  }


  /* =========================
     TRANSLATE
  ========================= */

  t(
    key: string
  ): string {

    return this.languageService
      .translate(key);
  }


  /* =========================
     AUTH
  ========================= */

  isLoggedIn(): boolean {

    const token =
      localStorage.getItem(
        'token'
      );

    return !!token;
  }


  isAdmin(): boolean {

    const role =
      localStorage.getItem(
        'role'
      );

    return (
      role?.toLowerCase() ===
      'admin'
    );
  }


  logout(): void {

    localStorage.removeItem(
      'token'
    );

    localStorage.removeItem(
      'userEmail'
    );

    localStorage.removeItem(
      'role'
    );

    this.desktopMenuOpen =
      false;

    this.sidebarOpen =
      false;

    this.router.navigate([
      '/login'
    ]);
  }


  /* =========================
     LANGUAGE CHANGE
  ========================= */

  changeLanguage(
    language: AppLanguage
  ): void {

    this.languageService
      .setLanguage(language);
  }


  /* =========================
     LOCATION DISPLAY
  ========================= */

  getSelectedLocationLabel():
    string {

    const keyMap:
      Record<string, string> = {

      Dhaka: 'dhaka',

      Chattogram:
        'chattogram',

      Sylhet: 'sylhet',

      Rajshahi:
        'rajshahi',

      Khulna: 'khulna'
    };


    const key =
      keyMap[
        this.selectedLocation
      ];


    return key
      ? this.t(key)
      : this.selectedLocation;
  }


  /* =========================
     HOME
  ========================= */

 goHome(): void {

  this.searchText = '';

  this.state.setSearch('');

  this.state.setCategory(0);

  this.showMobileSearch = false;

  this.state.setMobileSearch(false);

  this.showLocationMenu = false;

  this.desktopMenuOpen = false;

  this.sidebarOpen = false;

  this.router.navigate([
    '/'
  ]);
}

  /* =========================
     SEARCH
  ========================= */

  search(): void {

    const value =
      this.searchText.trim();

    this.state.setSearch(
      value
    );

    if (
      this.router.url
        .split('?')[0] !== '/'
    ) {

      this.router.navigate([
        '/'
      ]);
    }
  }


  /* =========================
     CLEAR SEARCH
  ========================= */

  clearSearch(): void {

    this.searchText = '';

    this.state.setSearch('');

    if (
      this.router.url
        .split('?')[0] !== '/'
    ) {

      this.router.navigate([
        '/'
      ]);
    }
  }


  /* =========================
     LOCATION
  ========================= */

  toggleLocationMenu(
    event?: MouseEvent
  ): void {

    if (event) {
      event.stopPropagation();
    }

    this.desktopMenuOpen =
      false;

    this.showLocationMenu =
      !this.showLocationMenu;

    if (this.showLocationMenu) {
      this.locationMenuStep = 'main';
    }
  }


  showCityList(): void {

    this.locationMenuStep = 'cities';
  }


  backToLocationMain(): void {

    this.locationMenuStep = 'main';

    this.locationSearchText = '';
    this.locationSearchResults = [];
  }


  selectLocation(
    location: string
  ): void {

    this.selectedLocation =
      location;

    this.showLocationMenu =
      false;

    this.locationMenuStep = 'main';

    this.locationSearchText = '';
    this.locationSearchResults = [];

    localStorage.setItem(
      'selectedLocation',
      location
    );
  }


  /* =========================
     LOCATION — MANUAL SEARCH
     (city list step-এর উপরে থাকা সার্চ বক্স —
     ইউজার নিজের এলাকা/মহল্লার নাম টাইপ করলে
     Nominatim/OSM থেকে matching জায়গার লিস্ট
     দেখায়, ৩৫০ms debounce দিয়ে যাতে প্রতিটা
     কি-স্ট্রোকে API কল না হয়)
  ========================= */

  onLocationSearchInput(): void {

    const query =
      this.locationSearchText.trim();

    if (this.locationSearchDebounce) {
      clearTimeout(this.locationSearchDebounce);
    }

    if (query.length < 3) {

      this.locationSearchResults = [];
      this.locationSearching = false;

      return;
    }

    this.locationSearching = true;

    this.locationSearchDebounce = setTimeout(async () => {

      const results =
        await this.mapLoader.search(query);

      // ততক্ষণে ইউজার আরো টাইপ করে থাকলে/সার্চ বক্স খালি করে
      // থাকলে পুরনো রেজাল্ট আর দেখানো হবে না
      if (
        this.locationSearchText.trim() === query
      ) {

        this.locationSearchResults = results;
        this.locationSearching = false;

        this.cdr.markForCheck();
      }

    }, 350);
  }


  async selectSearchResult(
    result: { label: string; lat: number; lng: number }
  ): Promise<void> {

    // area-level short label (যেমন "Mirpur, Dhaka") বানানোর
    // চেষ্টা করা হয়, না পেলে সার্চ রেজাল্টের পুরো নামটাই ব্যবহার হয়
    const shortLabel =
      await this.buildLocationLabel(result.lat, result.lng);

    this.selectLocation(
      shortLabel || result.label
    );

    this.cdr.markForCheck();
  }


  /* =========================
     USE MY CURRENT LOCATION
     (নেভবারের জন্য)
  ========================= */

  useCurrentLocationNavbar(): void {

    if (!this.isBrowser || !navigator.geolocation) {

      this.openLocationHelp('unsupported');
      return;
    }

    this.locatingCurrentLocation = true;

    navigator.geolocation.getCurrentPosition(

      async (pos) => {

        const lat = pos.coords.latitude;
        const lng = pos.coords.longitude;

        const label =
          await this.buildLocationLabel(lat, lng, true);

        this.locatingCurrentLocation = false;

        this.selectLocation(label || 'Dhaka');

        // ⚠️ ZONELESS FIX: navigator.geolocation callbacks and raw
        // fetch() (inside reverseGeocode) run outside Angular's
        // tracked contexts, so the app never knows state changed.
        // Without this, the UI stayed stuck on "Finding your
        // location..." forever even though the work had finished.
        this.cdr.markForCheck();
      },

      (err) => {

        this.locatingCurrentLocation = false;

        // ⚠️ LOCATION-OFF FIX: previously this just showed a plain
        // alert() with no way to actually fix the problem, so once
        // a user denied the permission once, the button looked
        // "broken" forever (the browser won't re-prompt). Now we
        // open an in-app help panel — same on mobile and desktop —
        // that explains *why* it failed and exactly where to turn
        // location back on for their device/browser, with a
        // "Try Again" button and (on Android) a real deep-link
        // into the system Location settings.
        if (err && err.code === err.PERMISSION_DENIED) {

          this.openLocationHelp('denied');

        } else if (err && err.code === err.POSITION_UNAVAILABLE) {

          this.openLocationHelp('unavailable');

        } else if (err && err.code === err.TIMEOUT) {

          this.openLocationHelp('timeout');

        } else {

          this.openLocationHelp('denied');
        }

        // ⚠️ ZONELESS FIX: same as above — geolocation error
        // callback is untracked by Angular, so force a UI update.
        this.cdr.markForCheck();
      },

      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  }


  /* =========================
     LOCATION OFF -> HELP PANEL
     (মোবাইল/ডেস্কটপ উভয় জায়গা থেকেই
     useCurrentLocationNavbar() এই একই
     মেথড কল করে, তাই ফিক্স একবারেই
     দুই জায়গায় কাজ করবে)
  ========================= */

  openLocationHelp(
    reason: 'denied' | 'unavailable' | 'timeout' | 'unsupported'
  ): void {

    this.locationHelpReason = reason;
    this.showLocationHelp = true;
    this.showLocationMenu = false;

    this.cdr.markForCheck();
  }


  closeLocationHelp(): void {

    this.showLocationHelp = false;
  }


  retryLocation(): void {

    this.showLocationHelp = false;
    this.useCurrentLocationNavbar();
  }


  goToCityListFromHelp(): void {

    this.showLocationHelp = false;
    this.locationMenuStep = 'cities';
    this.showLocationMenu = true;
  }


  get isAndroid(): boolean {

    return (
      this.isBrowser &&
      /android/i.test(navigator.userAgent)
    );
  }


  get isIOS(): boolean {

    return (
      this.isBrowser &&
      /iphone|ipad|ipod/i.test(navigator.userAgent)
    );
  }


  get isDesktop(): boolean {

    return !this.isAndroid && !this.isIOS;
  }


  // ব্রাউজার ডিটেকশন — ডেস্কটপে সঠিক, ব্রাউজার-নির্দিষ্ট instruction
  // দেখানোর জন্য (Chrome আর Firefox-এ location allow করার ধাপ
  // আলাদা, তাই generic instruction না দিয়ে সঠিকটাই দেখানো হয়)
  get browserName():
    'chrome' | 'edge' | 'firefox' | 'safari' | 'samsung' | 'opera' | 'other' {

    if (!this.isBrowser) {
      return 'other';
    }

    const ua = navigator.userAgent;

    if (/EdgA|Edg\//.test(ua)) return 'edge';
    if (/SamsungBrowser/.test(ua)) return 'samsung';
    if (/OPR\/|Opera/.test(ua)) return 'opera';
    if (/Firefox|FxiOS/.test(ua)) return 'firefox';
    if (/CriOS|Chrome/.test(ua)) return 'chrome';
    if (/Safari/.test(ua)) return 'safari';

    return 'other';
  }


  // Chrome/Edge/Opera (সব Chromium-ভিত্তিক) একটা বিশেষ
  // "chrome://settings/content/siteDetails?site=..." লিংক সাপোর্ট
  // করে যেটা ওই সাইটের Location permission সরাসরি খুলে দেয় —
  // কিন্তু নিরাপত্তার কারণে কোনো ওয়েবপেজ JS দিয়ে সরাসরি chrome://
  // এ navigate করাতে পারে না। তাই আমরা লিংকটা clipboard-এ copy করে
  // দিই — user শুধু address bar-এ paste + Enter চাপলেই সরাসরি
  // সেই permission পেজে চলে যাবে। এটা সত্যিই কাজ করে, কোনো fake
  // promise না।
  get canCopySettingsLink(): boolean {

    return (
      this.isDesktop &&
      ['chrome', 'edge', 'opera', 'samsung'].includes(this.browserName) &&
      this.isBrowser &&
      !!navigator.clipboard
    );
  }


  settingsLinkCopied = false;


  copySettingsLink(): void {

    if (!this.isBrowser || !navigator.clipboard) {
      return;
    }

    const link =
      'chrome://settings/content/siteDetails?site=' +
      encodeURIComponent(window.location.origin);

    navigator.clipboard
      .writeText(link)
      .then(() => {

        this.settingsLinkCopied = true;
        this.cdr.markForCheck();

        setTimeout(() => {
          this.settingsLinkCopied = false;
          this.cdr.markForCheck();
        }, 3000);
      })
      .catch(() => {
        // clipboard write ব্যর্থ হলেও নিচের step-by-step নির্দেশনা তো আছেই
      });
  }


  // Android Chrome একটি বিশেষ intent:// URI মেনে চলে যা সরাসরি
  // সিস্টেমের Location সেটিংস স্ক্রিন খুলে দিতে পারে — এটা আসলেই
  // কাজ করে। কিন্তু iOS Safari এবং ডেস্কটপ ব্রাউজারে security
  // কারণে ওয়েবপেজ থেকে সরাসরি browser/OS-এর privacy settings খোলা
  // সম্ভব না (কোনো ওয়েবসাইটই এটা পারে না) — তাই ওই ক্ষেত্রে
  // step-by-step নির্দেশনাই একমাত্র উপায়, যা modal-এ দেখানো হয়।
  openDeviceLocationSettings(): void {

    if (!this.isBrowser || !this.isAndroid) {
      return;
    }

    try {

      window.location.href =
        'intent:#Intent;action=android.settings.LOCATION_SOURCE_SETTINGS;end';

    } catch {
      // Deep link ব্যর্থ হলেও modal-এর ধাপগুলো তো আছেই
    }
  }


  /* =========================
     DESKTOP 3-DASH MENU
  ========================= */

  toggleDesktopMenu(
    event: MouseEvent
  ): void {

    event.stopPropagation();

    this.showLocationMenu =
      false;

    this.desktopMenuOpen =
      !this.desktopMenuOpen;
  }


  closeDesktopMenu(): void {

    this.desktopMenuOpen =
      false;
  }


  /* =========================
     DOCUMENT CLICK
  ========================= */

  @HostListener(
    'document:click'
  )
  closeMenus(): void {

    this.showLocationMenu =
      false;

    this.desktopMenuOpen =
      false;
  }

@HostListener('window:resize')
onResize(): void {

  this.isMobile = window.innerWidth <= 768;

}
  /* =========================
     CHAT
  ========================= */

  toggleChat(): void {

    this.showChat =
      !this.showChat;
  }


  /* =========================
     MOBILE SIDEBAR
  ========================= */

  toggleSidebar(): void {

    this.sidebarOpen =
      !this.sidebarOpen;
  }

toggleMobileSearch(): void {

  this.showMobileSearch =
    !this.showMobileSearch;

  this.state.setMobileSearch(
    this.showMobileSearch
  );

  if (this.showMobileSearch) {

    this.router.navigate(['/']);

  } else {

    this.searchText = '';

    this.state.setSearch('');

  }

}
  
  /* =========================
     MOBILE CATEGORY
  ========================= */

onMobileCategory(
  data: any
): void {

  if (!data || !data.id) {
    this.sidebarOpen = false;
    return;
  }

  this.searchText = '';

  this.state.setSearch('');

  this.state.setCategory(
    Number(data.id)
  );

  this.sidebarOpen = false;

  this.router.navigateByUrl('/');
}


  /* =========================
     CART DRAWER
  ========================= */

openCartDrawer(): void {

  document.body.classList.add('cart-open');

  window.dispatchEvent(
    new CustomEvent('open-cart-drawer')
  );

}

}